import { AGENT_TILE_WIDTH, AgentTile } from '@/components/AgentTile';
import { IAgent } from '@d-id/types';
import styled from '@emotion/styled';

const SectionTitle = styled.h2`
    color: ${({ theme }) => theme.colors.black[700]};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.32px;
    margin: 32px 0 16px;
`;

export const AgentsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${AGENT_TILE_WIDTH}px, 1fr));
    grid-row: 1; /* Ensure each row takes up equal height */
    grid-gap: 24px;
    justify-content: space-between;
`;

interface Props {
    agents: IAgent[];
    title: string;
    onDelete: (agent: IAgent) => void;
    onEmbed: (agent: IAgent) => void;
    onRemoveEmbed: (agent: IAgent) => void;
    onAgentUpgrade: (onAgentUpgrade: IAgent) => void;
    onEdit: (agent: IAgent) => void;
    clientKey: any;
}

export const AgentsList = ({ agents, onDelete, onEmbed, onRemoveEmbed, onAgentUpgrade, title, clientKey, onEdit }: Props) => {
    return (
        <>
            <SectionTitle>{title}</SectionTitle>
            <AgentsContainer>
                {agents.map(agent => (
                    <AgentTile
                        key={agent.id}
                        agent={agent}
                        onDelete={onDelete}
                        onEmbed={onEmbed}
                        onUpgrade={onAgentUpgrade}
                        onRemoveEmbed={onRemoveEmbed}
                        clientKey={clientKey?.client_key}
                        onEdit={onEdit}
                    />
                ))}
            </AgentsContainer>
        </>
    );
};
